module.exports = __webpack_public_path__ + "assets/flyt-icons_helipad-pin.ae339de2.svg";